<template>
  <div class="upsell-callout-container">
    <!-- Dynamic icon -->
    <Component
      :is="iconComponent"
      class="upsell-icon"
      height="40"
      width="40"
    />
    <a
      v-if="upsellCallout.absolute_url"
      :href="`${upsellCallout.absolute_url}?ref=pdp-ups-callout`"
    >
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="upsellCallout.upsell_text" />
    </a>
    <div
      v-else
      v-html="upsellCallout.upsell_text"
    />
  </div>
</template>
<script>
import UpsellPlusIcon from '~/static/campaigns/upsell-plus-icon.svg?inline';
import UpsellEarningIcon from '~/static/campaigns/earning-icon.svg?inline';
import UpsellExposureIcon from '~/static/campaigns/exposure-icon.svg?inline';
import UpsellSpreadWorldIcon from '~/static/campaigns/spread-world-icon.svg?inline';

// These props must match Icon choices in Deals model. See deals/models.py
const UPSELL_ICON = {
  appsumo_plus: UpsellPlusIcon,
  earning: UpsellEarningIcon,
  exposure: UpsellExposureIcon,
  spread_word: UpsellSpreadWorldIcon,
};

export default {
  props: {
    upsellCallout: {
      type: Object,
      required: true,
    },
  },
  computed: {
    iconComponent() {
      return UPSELL_ICON[this.upsellCallout.upsell_icon] || UpsellPlusIcon;
    },
  },
};
</script>
<style lang="scss" scoped>
  @import '~/styles/dorado/themes/dorado';
  @import '~/styles/utils/breakpoints';

  .upsell-callout-container {
    align-items: center;
    background: $gray-100;
    border-radius: 4px;
    display: flex;
    margin: 0 24px 24px;
    padding: 8px;
  }

  .upsell-icon {
    margin-right: 0.5rem;
    overflow: visible;
    width: 40px;
  }

  @include media-breakpoint-down(md) {
    .upsell-callout-container {
      margin: 24px 0;
    }
  }
</style>
